import { render, staticRenderFns } from "./CustomerReturnLines.vue?vue&type=template&id=018f6b35"
import script from "./CustomerReturnLines.vue?vue&type=script&lang=js"
export * from "./CustomerReturnLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports